// @ts-nocheck
import * as React from "react";

const ClipboardFill: React.FC = () => {
    return (
        <svg focusable="false" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13 4V13.5C12.9988 13.8975 12.8404 14.2783 12.5593 14.5593C12.2783 14.8404 11.8975 14.9988 11.5 15H4.5C4.10254 14.9988 3.7217 14.8404 3.44065 14.5593C3.1596 14.2783 3.00119 13.8975 3 13.5V4C3.00119 3.60254 3.1596 3.2217 3.44065 2.94065C3.7217 2.6596 4.10254 2.50119 4.5 2.5V3.5C4.50119 3.89746 4.6596 4.2783 4.94065 4.55935C5.2217 4.8404 5.60254 4.99881 6 5H10C10.3975 4.99881 10.7783 4.8404 11.0593 4.55935C11.3404 4.2783 11.4988 3.89746 11.5 3.5V2.5C11.8975 2.50119 12.2783 2.6596 12.5593 2.94065C12.8404 3.2217 12.9988 3.60254 13 4Z"
                fill="currentColor"
                fillRule="evenodd"
            />
            <path
                d="M6 4.00005C5.86739 4.00005 5.74021 3.94737 5.64645 3.85361C5.55268 3.75984 5.5 3.63266 5.5 3.50005V2.50005C5.5 2.36744 5.55268 2.24027 5.64645 2.1465C5.74021 2.05273 5.86739 2.00005 6 2.00005H6.5625L6.7075 1.75005C6.82113 1.55254 6.97884 1.38394 7.16834 1.2574C7.35785 1.13086 7.57402 1.04981 7.8 1.02055C7.86314 1.00722 7.92747 1.00035 7.992 1.00005C8.0621 0.999355 8.13211 1.00555 8.201 1.01855C8.42703 1.04824 8.64316 1.1297 8.83256 1.25658C9.02196 1.38345 9.17953 1.55233 9.293 1.75005L9.4375 2.00005H10C10.1326 2.00005 10.2598 2.05273 10.3536 2.1465C10.4473 2.24027 10.5 2.36744 10.5 2.50005V3.50005C10.5 3.63266 10.4473 3.75984 10.3536 3.85361C10.2598 3.94737 10.1326 4.00005 10 4.00005H6Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ClipboardFill);
